module.exports = __webpack_public_path__ + "media/images/icons/filled/pay-circle-9c95061c6c2f277925e50bdb096fbd14.svg";